var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.topBarTop()
  var m1 = _vm.topBarHeight()
  var m2 = !(m1 == 0) ? _vm.topBarHeight() : null
  var m3 = _vm.topBarHeight()
  var m4 = _vm.topBarTop()
  var m5 = _vm.topBarHeight()
  var g0 =
    _vm.shop_info != "" && _vm.nav_type == 99 ? _vm.listData.length : null
  var l0 =
    _vm.shop_info != "" && _vm.isLieBiao == true && _vm.nav_type == 0
      ? _vm.__map(_vm.product_list, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = _vm.listData.length
          return {
            $orig: $orig,
            g1: g1,
          }
        })
      : null
  var g2 = _vm.shop_info != "" && _vm.nav_type == 1 ? _vm.liveList.length : null
  var g3 =
    _vm.shop_info != "" ? _vm.listData.length >= 1 && _vm.nav_type == 2 : null
  var g4 =
    _vm.nav_type == 0 || _vm.nav_type == 99
      ? _vm.product_list.length == 0 && !_vm.loading
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        m5: m5,
        g0: g0,
        l0: l0,
        g2: g2,
        g3: g3,
        g4: g4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }